import { Injectable } from "@angular/core";
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { KYMW1001Model } from '../kymw1001.model';
import { GetInitTopModel } from "../vo/get-init-top.model";


/**
 * フロントに必要な情報を取得するサービス
 *
 * @export GetInitTopService
 * @class GetInitTop
 * @extends {PlessResponder}
 */
@Injectable()
export class GetInitTopService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  public model: KYMW1001Model;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub,
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetInitTopService
   */
  private successFunc: Function;

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {string} リクエストXML
   * @memberof GetInitTopService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param vo
   * @memberof GetInitTopService
   */
  execute(model: KYMW1001Model, successFunc: Function): void {
    this.model = model;
    this.successFunc = successFunc;
    this.send('getInitTop', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetInitTopService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }

  /**
   * API通信失敗時の処理
   *
   * @param {string} status エラーステータス
   * @param {*} result エラー結果
   * @memberof GetInitTopService
   */
  exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
  }
}
